<body>
    <div class="container-fluid">
        <div class="container">
           <img src="../../../../assets/img/background/images.jpg" alt="">
        </div>
    </div>    
</body>